<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "SalesApprovalIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
